import { render, staticRenderFns } from "./PortraitImage.vue?vue&type=template&id=60cf48f8"
import script from "./PortraitImage.vue?vue&type=script&lang=js"
export * from "./PortraitImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports